import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../services/api';

export const useApiKeyAbilities = () => {
    return useQuery({
        queryKey: ['api-key-abilities'],
        queryFn: () => api.getApiKeyAbilities(),
        staleTime: Infinity,
    });
};

export const useApiKeys = () => {
    return useQuery({
        queryKey: ['api-keys'],
        queryFn: () => api.getApiKeys(),
    });
};

export const useCreateApiKey = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (data) => api.createApiKey(data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['api-keys'] });
        },
    });
};

export const useUpdateApiKey = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ id, data }) => api.updateApiKey(id, data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['api-keys'] });
        },
    });
};

export const useDeleteApiKey = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ id }) => api.deleteApiKey(id),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['api-keys'] });
        },
    });
};
